import { init, reactRouterV6BrowserTracingIntegration, withSentryReactRouterV6Routing } from '@sentry/react';
import { useEffect } from 'react';
import { createRoutesFromChildren, matchRoutes, Routes, useLocation, useNavigationType } from 'react-router-dom';

init({
  dsn: 'https://d8344fdba4984f3f967a0bb7be8f64a8@sentry.trafficon.eu/7',
  enabled: import.meta.env.MODE !== 'development',
  environment: import.meta.env.VITE_SENTRY_ENVIRONMENT,
  release: import.meta.env.VITE_SENTRY_RELEASE,
  integrations: [
    reactRouterV6BrowserTracingIntegration({
      useEffect,
      useLocation,
      useNavigationType,
      createRoutesFromChildren,
      matchRoutes,
    }),
  ],
  tracesSampleRate: import.meta.env.MODE === 'development' ? 1.0 : 0.1,
});

export const SentryRoutes = withSentryReactRouterV6Routing(Routes);
